import { jsx as _jsx } from "react/jsx-runtime";
import { StepLayout } from '@/components/step-layout.component';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
export default function ResultCategoryPage() {
    var _a = useState(''), image = _a[0], setImage = _a[1];
    var _b = useState(0), step = _b[0], setStep = _b[1];
    var _c = useState(null), heading = _c[0], setHeading = _c[1];
    var _d = useState(null), nav = _d[0], setNav = _d[1];
    return (_jsx(StepLayout, { progress: { phase: 2, step: step }, heading: heading, image: image, content: _jsx(Outlet, { context: {
                setImage: setImage,
                setHeading: setHeading,
                setNav: setNav,
                setStep: setStep,
            } }), nav: nav }));
}
export function ResultCategoryOutlet() {
    return _jsx(Outlet, { context: useResultCategoryOutletContext() });
}
